<template>
    <div class="vue-filter-wrapper filter col-12" :class="open ? 'open' : 'closed'">
        <p v-if="title" @click="handleClick">{{ title }}</p>

        <div ref="filterWrapper" v-show-slide="open">
            <div class="mt-4">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "OccasionFilterGroup",

    props: ['title', 'showOpen'],

    data() {
        return {
            open: false,
        }
    },

    mounted() {
        if (this.showOpen === true) {
            this.handleClick();
        }
    },

    methods: {
        handleClick() {
            this.open = ! this.open;

            if (this.open) {
                setTimeout(() => {
                    this.$refs.filterWrapper.style.overflow = "unset";
                }, 400)
                return;
            }

            if (!this.open) {
                this.$refs.filterWrapper.style.overflow = "hidden";
            }
        }
    }
}
</script>